import { createContext, useContext } from 'react';

/** Set by read-only boundaries; shared inputs a disabled fieldset can't reach (rich text, drag and drop) read it. */
export const ReadOnlyScopeContext = createContext(false);

export const useIsInReadOnlyScope = (): boolean =>
  useContext(ReadOnlyScopeContext);
